import styled from 'styled-components';
import chZindex from '../../../zIndex';

let isIpad = false;
if (typeof window !== 'undefined' && typeof navigator !== 'undefined') {
  isIpad = /iPad/.test(navigator.userAgent) && !window.MSStream;
}

export const ProgressContainer = styled.div`
  display: flex;
  height: 170px;
  flex-direction: column;
  justify-content: space-between;
  position: fixed;
  right: 30px;
  top: 50%;
  transform: translateY(-50%);
  z-index: ${chZindex.progressIndicator};
`;

export const ProgressDot = styled.span`
  background: ${(props) =>
    props.active ? 'rgba(255, 255, 255, 1.0)' : 'rgba(255, 255, 255, 0.4)'};
  border-radius: 50%;
  display: ${!isIpad ? 'block' : 'none'};
  height: 8px;
  transition: all 300ms ease-in-out;
  width: 8px;
  cursor: pointer;

  &:hover {
    background: rgba(255, 255, 255, 0.75);
  }
`;
